<div class="login-bg d-flex align-items-center justify-content-center w-100 min-vh-100 px-3 py-5">

  <div class="login-card w-100 p-4 p-md-5">

    <div class="d-flex align-items-center justify-content-center mb-4">
      <img class="logo me-2" src="assets/logo/gks-dark.svg" [alt]="'app.name'|translate">
      <span class="fs-xsmall fw-800 color-brand-primary">{{'app.panel_name'|translate|uppercase}}</span>
    </div>

    <form [formGroup]="fg" (ngSubmit)="signIn()">

      <h2 class="fs-title-medium mb-2 color-gray-950 fw-800 text-center">{{'auth.login'|translate}}</h2>

      <p class="fs-normal color-gray-600 fw-350 text-center mb-0" style="letter-spacing: -0.7px;">
        {{'auth.login_desc'|translate}}
      </p>

      <div class="mt-4 w-100">
        <app-gray-text-input
          [hasErr]="isSubmitted && fg.get('email')?.invalid"
          icon="mail-bordered" [placeholder]="'labels.mail'|translate"
          formControlName="email"></app-gray-text-input>
        <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('email')?.errors">
          <p *ngIf="fg.get('email')?.errors?.required">
            {{'errors.required'|translate}}
          </p>
          <p *ngIf="fg.get('email')?.errors?.email">
            {{'errors.invalid_mail'|translate}}
          </p>
        </div>
      </div>

      <div class="mt-3 w-100">
        <app-gray-password-input
          [hasErr]="isSubmitted && fg.get('password')?.invalid"
          icon="lock-bordered" [placeholder]="'labels.password'|translate"
          formControlName="password"></app-gray-password-input>
        <div class="form-errors mt-1" *ngIf="isSubmitted && fg.get('password')?.errors">
          <p *ngIf="fg.get('password')?.errors?.required">
            {{'errors.required'|translate}}
          </p>
          <p *ngIf="fg.get('password')?.errors?.minlength">
            {{'errors.min_char'|translate: {c: 6} }}
          </p>
          <p *ngIf="fg.get('password')?.errors?.maxlength">
            {{'errors.max_char'|translate: {c: 50} }}
          </p>
        </div>
      </div>

      <div class="form-errors mt-3" *ngIf="loginErrKey">
        <p>{{loginErrKey|translate}}</p>
      </div>

      <div class="mt-4 w-100">
        <app-gray-button
          type="submit" color="primary" [isLoading]="isLoading" [disabled]="isLoading"
          [text]="'buttons.login'|translate"></app-gray-button>
      </div>

    </form>
  </div>

</div>
